import styled from 'styled-components';

export const OverviewWrapper = styled.div`
    display:flex;
    justify-content:center;
    background:#ffffff;
    height:auto;
    width:80%;
    margin-left:10%;
    margin-top:4%;
    margin-bottom:4%;

    @media screen and (max-width:960px){

    flex-direction:column-reverse;
    
 } 
   
`